import React, { useEffect, useRef, useState } from "react";
import InfiniteGrid from "components/Grid";
import Category from "layout/dictionarySearch/Category";
import Item from "layout/dictionarySearch/Item";
import { useSelector } from "react-redux";
import { hoverSame, unhoverSame } from "utils";
import Header from "layout/dictionarySearch/folder/byDocument/categories/Header";
import Document from "layout/dictionarySearch/folder/byDocument/categories/Document";

const Categories = () => {
  const outerListRef = useRef(undefined);
  const innerListRef = useRef(undefined);
  const [rows, setRows] = useState([]);
  const documents = useSelector((state) => state.dictionarySearch.documents);

  const docsOccurrences = documents.map((d) => d.occurrences);

  useEffect(() => {
    const result = [];
    documents.forEach((d) => {
      if (!d.id) {
        return;
      }
      result.push(
        <Document doc={d} maxOccurrences={Math.max(...docsOccurrences)} />
      );
      if (d.expanded) {
        d.dictionary.categories?.forEach((category) => {
          result.push(
            <Category
              category={category}
              maxOccurrences={Math.max(...docsOccurrences)}
              docId={d.id}
            />
          );
          if (category.expanded) {
            category.items?.forEach((item) => {
              result.push(
                <Item
                  item={item}
                  maxOccurrences={Math.max(...docsOccurrences)}
                  docId={d.id}
                />
              );
            });
          }
        });
      }
    });

    setRows(result);
  }, [documents]);

  const renderRow = ({ rowIndex, style }) => {
    return (
      <div
        style={style}
        className={`item item-${rowIndex}`}
        onMouseOver={() => hoverSame(rowIndex)}
        onFocus={() => hoverSame(rowIndex)}
        onMouseOut={unhoverSame}
        onBlur={unhoverSame}
      >
        {rows[rowIndex]}
      </div>
    );
  };

  return (
    <div className="categories" data-testid="categories-pane">
      <Header docsLength={documents.length} />
      <div className="categories__body" role="presentation" tabIndex={-1}>
        <InfiniteGrid
          rowSize={26}
          outerRef={outerListRef}
          innerRef={innerListRef}
          rowCount={rows.length}
          renderRow={renderRow}
          columnCount={1}
        />
      </div>
    </div>
  );
};

export default Categories;
